'use client';

import { type ChangeEvent, type InputHTMLAttributes } from 'react';
import { useController } from 'react-hook-form';

import { CheckboxInput } from '../checkbox-input/checkbox-input';

type CheckboxFieldProps = InputHTMLAttributes<HTMLInputElement> & {
  dataTestId?: string;
  id?: string;
  isSwitch?: boolean;
  label: string;
  name: string;
  pushToRight?: boolean;
  wrapperClassName?: string;
};

export const CheckboxField = ({ label, name, onChange, ...restProps }: CheckboxFieldProps) => {
  const {
    field: { onChange: fieldOnChange, value: fieldValue, ...restFieldProps },
  } = useController({ name });

  return (
    <CheckboxInput
      isChecked={fieldValue}
      label={label}
      {...restProps}
      {...restFieldProps}
      onChange={(event: ChangeEvent<HTMLInputElement>) => {
        fieldOnChange(event);
        onChange && onChange(event);
      }}
    />
  );
};
